
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="row">
    <div class="col-12 mb-4">
      <v-card>
        <v-card-title> </v-card-title>
        <div class="row">
          <h6 class="col-12">{{ $t("intram_service.service_title") }}</h6>
          <div class="col-lg-4 col-12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              solo
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <div class="col-lg-8 col-12 text-right">
            <v-btn color="default" dark class="mb-2" @click="dialog = true">{{
              $t("intram_service.add_service")
            }}</v-btn>
          </div>
        </div>
        <v-data-table
          no-headers
          :headers="headers"
          :items="services_datas"
          :search="search"
          :loading="services_datas === undefined || services_status"
          loading-text="Chargement en cours..."
          sort-by="label"
          class="elevation-0 mt-0 pt-0"
        >
          <template v-slot:item._logo="{ item }">
            <a :href="image_base_link + item._logo" target="_blank">
              <v-img
                :src="image_base_link + item._logo"
                :lazy-src="image_base_link + item._logo"
                max-width="40"
                max-height="40"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </a>
          </template>
          <template v-slot:item._status="{ item }">
            <v-switch
              @click="valideItem(item)"
              color="primary"
              :input-value="item._status ? 'true' : ''"
            ></v-switch>
          </template>
          <template v-slot:item._created_at="{ item }">
            {{ new Date(item._created_at).toLocaleDateString() }}
          </template>
          <template v-slot:item._description="{ item }">
            {{ limiText(item._description, 50) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <div style="text-align: right">
              <v-menu key="text" rounded="b-xl">
                <template v-slot:activator="{ attrs, on }">
                  <v-icon class="black--text" v-bind="attrs" v-on="on"
                    >mdi-dots-vertical</v-icon
                  >
                </template>
                <v-list>
                  <v-list-item
                    @click="
                      redirectByUrl('/admin/services/parameters/' + item._id)
                    "
                  >
                    <v-list-item-icon>
                      <v-icon color="#29B3A6"> mdi-cogs </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Paramètre </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    @click="
                      redirectByUrl('/admin/services/options/' + item._id)
                    "
                  >
                    <v-list-item-icon>
                      <v-icon color="#29B3A6"> mdi-animation </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Options </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    @click="redirectByUrl('/admin/services/stats/' + item._id)"
                  >
                    <v-list-item-icon>
                      <v-icon color="#29B3A6"> mdi-tune-variant </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Statistiques </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    @click="
                      redirectByUrl('/admin/services/attributs/' + item._id)
                    "
                  >
                    <v-list-item-icon>
                      <v-icon color="#29B3A6">
                        mdi-arrange-bring-forward
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        Attributs acquisition
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    @click="
                      redirectByUrl(
                        '/admin/services/save/attributs/' + item._id
                      )
                    "
                  >
                    <v-list-item-icon>
                      <v-icon color="#29B3A6">
                        mdi-content-save-move-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        Attributs de sauvagarde
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="description(item)">
                    <v-list-item-icon>
                      <v-icon color="#29B3A6"> mdi-eye </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Description </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="editItem(item)">
                    <v-list-item-icon>
                      <v-icon color="#29B3A6"> mdi-pencil </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Modifier </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="confimDeleteServices(item)">
                    <v-list-item-icon>
                      <v-icon color="red"> mdi-trash-can-outline </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Supprimer </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
          <template v-slot:no-data>
            {{ $t("no_data") }}
          </template>
        </v-data-table>
        <div class="col-12 text-right" style="background: #f8f8f8">
          <v-pagination
            elevation="0"
            v-model="page"
            :length="total_pages"
            :total-visible="7"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="getAllServices"
          ></v-pagination>
          <!-- product pagination -->
        </div>

        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-text>
              <v-text-field
                v-if="submitting"
                color="primary"
                loading
                disabled
              ></v-text-field>
              <v-alert v-if="errors.operation" dense outlined type="error">
                {{ errors.operation }}
              </v-alert>
              <v-form
                ref="form"
                v-model="valid"
                :lazy-validation="lazy"
                enctype="multipart/form-data"
              >
                <v-row>
                  <v-col cols="12" sm="12" class="mt-5">
                    <h3>Ajouter un nouveau service</h3>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <label
                      >Logo du service <br />
                      <small v-if="id"
                        >Ne cliquez que si vous souhaitez mettre à jour le logo
                        du service</small
                      ></label
                    >
                    <v-file-input
                      v-model="files"
                      accept="image/png, image/jpeg"
                      ref="files"
                      :rules="fileRules"
                      solo
                      placeholder="Téléverser l'image du service"
                      label="Téléverser l'image du service"
                      prepend-icon="mdi-paperclip"
                    >
                      <template v-slot:selection="{ text }">
                        <v-chip small label color="primary">
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <label>Nom du service</label>
                    <v-text-field
                      solo
                      :rules="inputRules"
                      v-model="editedItem._name"
                      :label="$t('name')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <label>Mode de Validation</label>
                    <v-autocomplete
                      :rules="inputRules"
                      v-model="editedItem._verification_mode"
                      :items="items"
                      solo
                      chips
                      small-chips
                      label="Mode de validation"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <label>Statut</label>
                    <v-autocomplete
                      :rules="inputRules"
                      v-model="serviceStatus"
                      :items="status"
                      solo
                      chips
                      small-chips
                      label="Statut"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <label>Activation</label>
                    <v-autocomplete
                      :rules="inputRules"
                      v-model="availability"
                      :items="activations"
                      solo
                      chips
                      small-chips
                      label="Activation"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <label>Pays de deploiement</label>
                    <v-autocomplete
                      :rules="inputRules"
                      v-model="editedItem._country"
                      :items="countries"
                      item-value="_id"
                      item-text="_name"
                      solo
                      chips
                      small-chips
                      label="Pays"
                      multiple
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <label>Description</label>
                    <v-textarea
                      solo
                      :rules="descriptionRules"
                      v-model="editedItem._description"
                      name="input-7-4"
                      rows="2"
                      :label="$t('description')"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="dark" @click.prevent="close">{{
                $t("cancel")
              }}</v-btn>
              <v-btn
                color="primary"
                :loading="submitting"
                :disabled="!valid || mis"
                @click.prevent="save"
                >{{ id ? $t("update") : $t("save") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as Swal from "sweetalert2";
import helpers from "../../../mixins/helpers";
import { client } from "../../../store/services/client";
import { env } from "../../../../env";
export default {
  name: "services",
  mixins: [helpers(this)],
  data() {
    return {
      page: 0,
      total_pages: 0,
      submitting: false,
      valid: true,
      lazy: false,
      mis: false,
      errors: {},
      files: [],
      search: "",
      dialog: "",
      items: ["Api", "Manual"],
      services_datas: undefined,
      services_status: false,
      status: ["Actif", "Inactif"],
      activations: ["Tous", "Personalisée"],
      availability: "",
      gateway_base_link: env.gateway,
      image_base_link: env.image_base_url,
      customSnack: {
        snackbar: false,
        text: "",
        snackcolor: "black",
        snackbBtnColor: "white",
        snacktimeout: 2000,
      },
      id: undefined,
      headers: [
        { text: this.$t("intram_service.status"), value: "_status" },

        { text: this.$t("logo"), value: "_logo" },
        {
          text: this.$t("name"),
          align: "start",
          sortable: false,
          value: "_name",
        },

        {
          text: this.$t("intram_service.validation_mode"),
          value: "_verification_mode",
        },
        //{ text: this.$t("intram_service.country"), value: "_country" },
        { text: this.$t("description"), value: "_description" },
        //{ text: this.$t("date"), value: "_created_at" },
        { text: "", value: "actions", sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        _name: "",
        _logo: "",
        _country: "",
        _description: "",
        _status: true,
        _verification_mode: "",
        _created_at: new Date(),
        _id: "",
      },
      defaultItem: {
        _name: "",
        _logo: "",
        _country: "",
        _description: "",
        _status: true,
        _verification_mode: "",
        _created_at: new Date(),
        _id: "",
      },
      serviceStatus: "",
      labelRules: [
        (v) => !!v || this.$t("name_required"),
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      inputRules: [
        (v) => !!v || this.$t("value_required"),
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      descriptionRules: [(v) => !!v || this.$t("description_required")],
      codeRules: [(v) => !!v || this.$t("code_required")],
      fileRules: [(v) => !!v || this.$t("file_required")],
    };
  },
  computed: {
    ...mapState("auth/", ["countries"]),
  },
  mounted() {
    this.$store.dispatch("auth/getCountries");
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    initialize() {
      this.getAllServices();
    },
    editItem(item) {
      // this.editedIndex = this.services_datas.indexOf(item)
      this.editedItem = item;
      this.dialog = true;
      this.id = item._id;
    },

    description(item) {
      Swal.fire({
        title: this.$t("description"),
        timerProgressBar: false,
        text: item._description,
        confirmButtonText: "Fermer",
        confirmButtonColor: "#29B3A6",
      });
    },
    valideItem(item) {
      let VueBox = this;
      let message = item._status
        ? "Vous êtes sûr de vouloir désactivé ce service ? Il ne sera plus visible sur l`application "
        : "Vous êtes sûr de vouloir effectué cette action ? Ce service sera visible aux utilisateurs";
      Swal.fire({
        icon: "warning",
        timerProgressBar: false,
        text: this.$t(message),
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
        showCancelButton: true,
        confirmButtonColor: "#29B3A6",
      }).then(async (result) => {
        if (result.value) {
          const response = await client({
            method: "post",
            url: "/services/admin/visibility",
            data: { _id: item._id },
          })
            .then((res) => res.data)
            .catch((error) => {
              console.log(error);
              this.service_status = false;
              return {
                error: true,
              };
            });
          this.service_status = false;
          if (response && !response.error) {
            this.getAllServices();
            Swal.fire({
              icon: "success",
              timer: 3000,
              timerProgressBar: false,
              text: this.$t(result.message),
              position: "top-end",
              showConfirmButton: false,
            });
            VueBox.toast("success", this.$t(result.message));
          }
        }
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$refs.form.reset();
    },
    async confimDeleteServices(item) {
      this.confirm_toast(
        "warning",
        "Suppression",
        "Êtes vous sûr de vouloir éffectuer cette action ?",
        "Oui, supprimer",
        "Non",
        await this.deleteServices(item)
      );
    },
    async deleteServices(item) {
      this.service_status = true;
      const response = await client({
        method: "post",
        url: `/services/delete`,
        data: { id: item._id },
      })
        .then((res) => res.data)
        .catch((error) => {
          console.log(error);
          this.service_status = false;
          return {
            error: true,
          };
        });
      this.service_status = false;
      if (response && !response.error) this.getAllServices();
    },
    async getAllServices(page = 1) {
      this.service_status = true;
      page = page - 1;
      const response = await client({
        method: "post",
        url: `/services`,
        data: { page: page },
      })
        .then((res) => res.data)
        .catch((error) => {
          console.log(error);
          this.service_status = false;
          return {
            error: true,
          };
        });
      this.service_status = false;
      if (response && !response.error) this.services_datas = response.services;
      this.page = response.page + 1;
      this.total_pages = response.total_pages;
    },
    async save() {
      let VueBox = this;
      let data = new FormData();
      let isActive = this.serviceStatus === "Actif";
      console.log(this.serviceStatus);

      data.append("_verification_mode", this.editedItem._verification_mode);
      data.append("_name", this.editedItem._name);
      data.append("_logo", this.files);
      data.append("_country", this.editedItem._country);
      data.append("_description", this.editedItem._description);
      data.append("_status", isActive);
      data.append(
        "_availability",
        this.availability === "Tous" ? "All" : "Custom"
      );
      console.log(data);
      let url = "/services/created";
      if (this.id) {
        data.append("_id", this.id);
      }
      this.submitting = true;
      const response = await client({
        method: "post",
        url: url,
        data: data,
      })
        .then((res) => res.data)
        .catch((error) => {
          console.log(error);
          this.submitting = false;
          return {
            error: true,
          };
        });
      this.submitting = false;
      if (response && !response.error)
        VueBox.toast("success", this.$t(response.message));
      VueBox.reset();
      VueBox.dialog = false;
      VueBox.id = undefined;
      VueBox.getAllServices();
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },
    getFileOriginalName(file) {
      return file.substr(file.lastIndexOf("/") + 1);
    },
  },
  created() {
    this.checkisDashboard();
    this.initialize();
  },
};
</script>
